export const GEMINI_MODELS = ['gemini-2.5-flash'];

export const DEFAULT_GEMINI_MODEL = GEMINI_MODELS[0];

export const GEMINI_MODEL_STORAGE_KEY = 'chineseRevisionAdmin.geminiModel';

export function normalizeGeminiModel(value) {
  const model = value != null ? String(value).trim() : '';
  return GEMINI_MODELS.includes(model) ? model : DEFAULT_GEMINI_MODEL;
}

export function getStoredGeminiModel() {
  try {
    return normalizeGeminiModel(window.localStorage.getItem(GEMINI_MODEL_STORAGE_KEY));
  } catch {
    return DEFAULT_GEMINI_MODEL;
  }
}

export function setStoredGeminiModel(value) {
  const model = normalizeGeminiModel(value);
  try {
    window.localStorage.setItem(GEMINI_MODEL_STORAGE_KEY, model);
  } catch {
    // Ignore storage failures; callers can still use the normalized value.
  }
  window.dispatchEvent(new CustomEvent('gemini-model-change', { detail: { model } }));
  return model;
}
